import { type WritableDraft } from 'immer';
import { type Observable, of } from 'rxjs';

import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type EngineState } from '../../../+state/engine';
import {
  AbstractAiElementHandler,
  applyFieldSize,
  getElement,
  getInitialProps,
  patchFieldLabel,
  upsertElement,
} from '../../../ai';

import { type DatetimeInputContext } from './datetime-input.definition';

export class DatetimeInputElementHandler extends AbstractAiElementHandler<'datetimeInput'> {
  readonly type = 'datetimeInput';

  prepare(context: DatetimeInputContext): Observable<DatetimeInputContext> {
    this.resolveElementIcon(context.element);

    return of(context);
  }

  process(context: DatetimeInputContext, draft: WritableDraft<EngineState>): void {
    let props: PartialPropsOf<'datetimeInput'> = getInitialProps<'datetimeInput'>(
      draft,
      context.element.id,
      {},
    );
    props = patchFieldLabel<'datetimeInput'>(props, context.element);

    if (context.element.isReadOnly !== undefined) {
      props = applyPropsPatch<'datetimeInput'>(props, {
        content: {
          date: { readonly: context.element.isReadOnly },
          time: { readonly: context.element.isReadOnly },
        },
      });
    }

    if (context.element.isDateEnabled !== undefined) {
      props = applyPropsPatch<'datetimeInput'>(props, {
        content: { date: { enabled: context.element.isDateEnabled } },
      });
    }

    if (context.element.isTimeEnabled !== undefined) {
      props = applyPropsPatch<'datetimeInput'>(props, {
        content: { time: { enabled: context.element.isTimeEnabled } },
      });
    }

    const { elementId } = upsertElement(draft, context, props);
    applyFieldSize<'datetimeInput'>(getElement(draft, elementId, 'datetimeInput'), context.element);
  }
}
